import { __decorate, __metadata } from "tslib";
import { ApiProperty } from '@nestjs/swagger';
import { Expose, Type } from 'class-transformer';
import { nameOf } from '@goparrot/common';
import { ReadAbstractItemDto, ReadStoreItemDto, ReadStoreItemGroupDto } from '../generated-dto';
import { StoreItemsExposeGroup, StoreItemTypeEnum } from '../enum';
import { PaginationResponseDto } from './PaginationResponseDto';
export class ItemListResponseDto {
}
__decorate([
    ApiProperty({ type: () => Object, isArray: true, description: 'Rows matched' }),
    Expose({ groups: [StoreItemsExposeGroup.READ] }),
    Type(() => ReadAbstractItemDto, {
        keepDiscriminatorProperty: true,
        discriminator: {
            property: nameOf('type'),
            subTypes: [
                { value: ReadStoreItemDto, name: StoreItemTypeEnum.STORE_ITEM },
                { value: ReadStoreItemGroupDto, name: StoreItemTypeEnum.STORE_ITEM_GROUP },
            ],
        },
    }),
    __metadata("design:type", Array)
], ItemListResponseDto.prototype, "data", void 0);
__decorate([
    ApiProperty({ type: () => PaginationResponseDto, description: 'Pagination details' }),
    Expose({ groups: [StoreItemsExposeGroup.READ] }),
    Type(() => PaginationResponseDto),
    __metadata("design:type", PaginationResponseDto)
], ItemListResponseDto.prototype, "pagination", void 0);
//# sourceMappingURL=ItemListResponseDto.js.map